// ─── API ───────────────────────────────────────────────────────────────────────
/** Relative API base — works behind any reverse-proxy without exposing a raw origin. */
export const API_BASE = process.env.REACT_APP_API_URL || '/api';

/** Derive the media-server origin by stripping the /api segment. */
export const MEDIA_BASE = API_BASE.replace(/\/api$/, '');

// ─── Category ──────────────────────────────────────────────────────────────────
export const ALL_CATEGORY = { slug: 'all', label: 'All Videos', icon: 'fa-th-large' };

// ─── Browse grid ───────────────────────────────────────────────────────────────
/** Number of columns used when calculating remote-control navigation row offsets. */
export const GRID_COLS = 4;

// ─── Branding defaults ─────────────────────────────────────────────────────────
export const DEFAULT_BRANDING = {
  org_name:      'Sreedhareeyam Ayurveda',
  tagline:       "World's Largest Ayurvedic Eye Care Network",
  primary_color: '#15803d',
  accent_color:  '#0f4c21',
  dark_color:    '#080c14',
  logo:          null,
};

// ─── Ayurveda quote pool (cycled by video id) ──────────────────────────────────
export const AYURVEDA_QUOTES = [
  '"The secret of health for both mind and body is not to mourn for the past, worry about the future, or anticipate troubles, but to live in the present moment wisely and earnestly." — Ayurvedic Philosophy',
  '"When diet is wrong, medicine is of no use. When diet is correct, medicine is of no need." — Ayurvedic Proverb',
  '"Health is not just the absence of disease. It is an expression of life — a joyful, loving vitality." — Ayurveda',
];
